const Etiquetas = {
    Ingles: {
        Tittle: 'Help Desk',
        ButtonNewTicket: 'Create New Tiket',
        Tab1: 'Open Tickets',
        Tab2: 'ClosedTickets',
    },
    
    Español: {
        Tittle: 'Mesa de Ayuda',
        ButtonNewTicket: 'Crear Nuevo Ticket',
        Tab1: 'Tickets Abiertos',
        Tab2: 'Tikets Cerrados',
    }
}

export default Etiquetas